import { gql } from '@apollo/client'

export const NETWORK_COPY_FROM_DEFAULT_MUTATION = gql`
  mutation NetworkCopyFromDefault($req: NetworkCopyFromDefaultRequest!) {
    networkCopyFromDefault(req: $req) {
      success
      network
    }
  }
`

// {
//   "req": {
//     "site": "spinco",
//     "network": "msnbc",
//     "networkBrand": {
//       "logoAndIcons": false,
//       "theme": false,
//       "themeOtt": false,
//       "themeApps": false
//     },
//     "networkSettings": true
//   }
// }